// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import { Button } from '../../design-system/components/Button';
import { toApiError } from '../http/errors';

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
  title?: string;
}

function statusLabel(status: number): string | null {
  if (status === 0) return 'Falha de conexão';
  if (status >= 500) return `Erro ${status} · servidor`;
  if (status >= 400) return `Erro ${status}`;
  return null;
}

export function ErrorState({
  error,
  onRetry,
  title = 'Não foi possível carregar',
}: ErrorStateProps) {
  const apiError = toApiError(error);
  const badge = statusLabel(apiError.status);
  return (
    <div className="f4-error-state" role="alert">
      <div className="row row--sm-gap">
        <span className="f4-error-state__title">{title}</span>
        {badge !== null ? <span className="label">{badge}</span> : null}
      </div>
      <span className="f4-error-state__message muted">{apiError.message}</span>
      {apiError.requestId !== null ? (
        <span className="label">Id da requisição: {apiError.requestId}</span>
      ) : null}
      {onRetry !== undefined ? (
        <Button variant="secondary" onClick={onRetry}>
          Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
